export const EVENT_STATUS_CONFIG = {
  soon: {
    label: "Em breve",
    color: "#1688ff",
    background: "#f4faff",
    border: "1px solid #1688ff",
  },
  active: {
    label: "Ativo",
    color: "#0f9f2b",
    background: "#eafbea",
    border: "1px solid #16b83e",
  },
  expired: {
    label: "Expirado",
    color: "#777777",
    background: "#f5f5f5",
    border: "1px solid #bdbdbd",
  },
};

export const EVENT_TYPE_CONFIG = {
  Ranking: {
    color: "#722ed1",
    background: "#fbf8ff",
    border: "1px solid #722ed1",
  },
  Lojinha: {
    color: "#fa8c16",
    background: "#fff7e6",
    border: "1px solid #fa8c16",
  },
};

export const EVENT_TYPE_OPTIONS = [
  { label: "Ranking", value: "Ranking" },
  { label: "Lojinha", value: "Lojinha" },
];

export const EVENT_TYPE_LOJINHA = "Lojinha";
